



export const superRoleName = "超级管理员";
export const systemRoleName = "系统管理员";



export const govRoleName = "政府管理员";

export const zoneRoleName = "组织账号";

export const commandCenterRoleName = "文明指挥中心";

export const superviseRoleName = "监管人员";

export const seatRoleName = "坐席客服";





export const shopRoleName = "商家";
export const serveRoleName = "服务人员";



export const insRoleName = "机构管理员";//del
export const medicinerRoleName = "医生";
export const nurseRoleName = "护士";

export const insRoleNameIns = "养老院机构";
export const insRoleNameHomeBed = "家庭床位机构";
export const insRoleNameDayCare = "日间照料机构";


export const zoneShengRoleName = "省民政";
export const zoneShiRoleName = "市民政";
export const zoneXQRoleName = "县区民政";
export const zoneJDRoleName = "街道民政";
export const zoneJWHRoleName = "居委会";



/////////////////////////////////////////


var host = window.location.host;
//var title = "孝贤智慧养老助残系统";
//var visualTitle = "孝贤智慧养老";
var support = "孝贤";
var title = "灌云县残联托养监管平台（西片区）";
var visualTitle = "灌云县残联托养监管平台";
var logoUrl = require("../assets/logo/xxky2.png");
var loginBgUrl = require("../assets/login-bg2.jpg");


//http
if(host=='118.89.66.71:8090'){
    title='智慧养老服务系统';
    support='智慧养老服务系统';
    logoUrl=require("../assets/logo-none.png");
    visualTitle = "智慧养老";
}


//https
if(host=='shop-adm.ynnqo.com:544'){
    title='康尔乐居家养老服务系统';
    support='贵州康尔乐养老服务有限公司';
    //logoUrl=require("../assets/logo-krl.png");
    logoUrl=require("../assets/logo-yq.png");
    visualTitle = "康尔乐居家养老";
}



export {
    title,support,visualTitle,logoUrl,loginBgUrl,
}


/////////////////////////////////////////

/////////////////////////////////////////
